module.exports = __webpack_public_path__ + "img/recart-2.ff39729a.jpg";